import Component from './Component';
import { getConfig, UserManager, getUser, getAccessTokenOrSignin } from '../lib/OidcHelper';

export default class PreferenceModal extends Component {

  load() {
    $('.js-login-choice-btn__login').on('click', this.startLogin );
    this.initPreferenceModal();
    super.load();
  }


  initPreferenceModal() {
    console.log('initPreferenceModal');
  }


  async startLogin(e) {
    console.log('startLogin');

    $(e.target).addClass('loading');
    // TODO: start login sequence
    // TODO: on return to page ask/prompt user if they wish to add local bookmarks to their account

    const config = getConfig(window.location);
    this.oidcUserManager = new UserManager(config);

    // populate current user details in the form from login
    const user = await getUser(this.oidcUserManager);
    console.log('user: ', user);
    if (!user) {
      console.log('not logged in.');
      // Depends on PreferenceMenu.js having created window.panelProps object.
      // We change to the Favourites panel.

      const token = await getAccessTokenOrSignin(this.oidcUserManager);
      if (token == null) {
        console.log('no token.');
      } else {
        // got a token so show panel user wanted.
        const profilePanel = document.querySelector('[data-title="Profile"]');
        window.panelProps.changePanel(profilePanel, window.panelProps.sliderUlWidth, window.panelProps.slideWidth);

        // thisComponent.initModal();
      }

      // hidePanel();  // ??
    }
  }

}


